import React from 'react';
import { useParams } from 'react-router-dom';
import { useMappingBootstrap } from './hooks/useMappingBootstrap';
import MappingLayout from './MappingLayout';

export default function MappingPage() {
  const params = useParams();
  useMappingBootstrap(params);
  return <MappingLayout />;
}
